import './HomePageCss/FAQSection.css';

import { useNavigate } from 'react-router-dom';

import AnimatedText from '../../AnimatedText';

export default function FAQSectionSection() {

    const navigator = useNavigate();

    const Qs = [
        
        {
            name: "General Queries"
        },
        {
            name: "Home Collection"
        },
        {
            name: "Diagnostic Test Information"
        },
        {
            name: "Payments"
        },
        {
            name: "Reports"
        },
        {
            name: "Contact and Support"
        }
    ]

    const handleLinkOn = (e) =>{
        // e.preventDefault;
        navigator("/faqs")
    }
    return (
        <>
            <div className="faqContainer">
                <div className="faqUpperSection">
                    <AnimatedText tag="h1" type="words" y={30}>
                       Frequently Asked Questions (FAQs)
                    </AnimatedText>
                </div>
                <div className="questionsSection">
                    {
                        Qs.map((q, indx) => (
                            <div className="qus" key={indx} onClick={handleLinkOn}>
                                
                                <p><span>+</span> {q.name}</p>

                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
}